// client/src/services/volunteersApi.js
// Volunteers (Roadmap Phase 5.2). Staff: /api/volunteers/:tenant (checked
// against the session, server/routes/volunteerRoutes.js). The volunteer's own
// shift link: /api/public/volunteers (no sign-in).

const BASE_URL = process.env.REACT_APP_BASE_URL?.replace(/\/$/, '') || '';

async function request(method, url, body) {
  const res = await fetch(`${BASE_URL}${url}`, {
    method,
    credentials: 'include',
    headers: body !== undefined ? { 'Content-Type': 'application/json' } : {},
    body: body !== undefined ? JSON.stringify(body) : undefined,
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    const err = new Error(data.message || data.error || `${res.status} ${res.statusText}`);
    err.response = { status: res.status, data };
    throw err;
  }
  return data;
}

const base = (tenantId) => `/api/volunteers/${Number(tenantId)}`;
const enc = encodeURIComponent;

export function errorText(err, fallback) {
  return err?.response?.data?.message || err?.response?.data?.error || fallback;
}

export const listVolunteerEvents = (tenantId) => request('GET', `${base(tenantId)}/events`);
export const getRoster = (tenantId, eventId) => request('GET', `${base(tenantId)}/events/${Number(eventId)}/roster`);
export const createShift = (tenantId, eventId, body) => request('POST', `${base(tenantId)}/events/${Number(eventId)}/shifts`, body);
export const updateShift = (tenantId, id, body) => request('PUT', `${base(tenantId)}/shifts/${Number(id)}`, body);
export const deleteShift = (tenantId, id) => request('DELETE', `${base(tenantId)}/shifts/${Number(id)}`);
export const addSignup = (tenantId, shiftId, body) => request('POST', `${base(tenantId)}/shifts/${Number(shiftId)}/signups`, body);
export const updateSignup = (tenantId, id, body) => request('PUT', `${base(tenantId)}/signups/${Number(id)}`, body);
export const cancelSignup = (tenantId, id) => request('POST', `${base(tenantId)}/signups/${Number(id)}/cancel`);
export const listSignupForms = (tenantId, eventId) => request('GET', `${base(tenantId)}/events/${Number(eventId)}/forms`);
export const createSignupForm = (tenantId, eventId) => request('POST', `${base(tenantId)}/events/${Number(eventId)}/forms`, {});
export const listVolunteerPeople = (tenantId, year) => request('GET', `${base(tenantId)}/people${year ? `?year=${Number(year)}` : ''}`);
export function getPersonHours(tenantId, { email, memberId } = {}) {
  const qs = new URLSearchParams();
  if (email) qs.set('email', email);
  if (memberId) qs.set('memberId', memberId);
  return request('GET', `${base(tenantId)}/person?${qs.toString()}`);
}

export const getVolunteerSignup = (token) => request('GET', `/api/public/volunteers/signup/${enc(token)}`);
export const cancelVolunteerSignup = (token) => request('POST', `/api/public/volunteers/signup/${enc(token)}/cancel`);

/** 2.5 → "2.5 h" / 1 → "1 h". */
export const formatHours = (h) => `${Math.round((Number(h) || 0) * 100) / 100} h`;
